var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import gsap from 'gsap';
import { ResourceCard, } from '../resourceCard/ResourceCard';
import './index.scss';
import SwiperCore, { Virtual, Navigation } from 'swiper';
// import CarouselArrow from './CarouselArrow';
SwiperCore.use([Virtual, Navigation]);
import '../../lib/styles/swiper.scss';
import { useWindowSize } from '../../hooks/useWindowSize';
import card0 from '../../assets/images/twoCards/MaskGroup.png';
import card1 from '../../assets/images/twoCards/MaskGroup-2.png';
var defaultProps = {
    data: {
        title: 'Delve into the Intelligent Financial Life™',
        resourceCardList: [
            {
                id: 'card-0',
                image: card0,
                type: 'white paper',
                title: 'The Intelligent Financial Life™',
                copy: 'Download the white paper that started it all. Bill Crager, Co-Founder and CEO of Envestnet, outlines why meeting consumer demand for an intelligently connected financial life is the future of our industry.',
                url: '/',
                ctaCopy: 'Read Now',
            },
            {
                id: 'card-1',
                image: card1,
                type: 'video',
                title: 'Unlocking the Network Effect',
                copy: 'See the far-reaching opportunities you can unlock for your business by focusing on an Intelligent Financial Life™ for each of your clients—and their network.',
                url: '/',
                ctaCopy: 'Watch Now',
            },
        ],
    },
};
export var TwoCards = function (_a) {
    var className = _a.className, _b = _a.data, title = _b.title, resourceCardList = _b.resourceCardList;
    var _c = useState(0), scrolledBy = _c[0], setScrolledBy = _c[1];
    var navigationPrevRef = useRef(null);
    var navigationNextRef = useRef(null);
    var width = useWindowSize()[0];
    var isMobile = width < 768;
    var isTablet = window.innerWidth < 1440;
    var isDesktop = window.innerWidth >= 1440;
    // const isTablet = window.innerWidth <= 1439;
    // const isDesktop = window.innerWidth >= 1440;
    var scrollHandler = function (e) {
        var target = e.target;
        var scrollLeft = target.scrollLeft, scrollWidth = target.scrollWidth, clientWidth = target.clientWidth;
        var width = scrollWidth - clientWidth;
        setScrolledBy((scrollLeft / width) * 100);
    };
    useEffect(function () {
        var tl = gsap.timeline({
            scrollTrigger: {
                trigger: '.twoCardsContainer',
                start: 'top center',
            },
        });
        tl.to(['.twocards_title', '.twocards_cards'], {
            autoAlpha: 1,
            duration: 1,
            stagger: 0.5,
        });
    }, []);
    return (_jsx("div", __assign({ className: "text-white w-100vw flex flex-col md:items-center snap-start twoCardsContainer " + (className || '') }, { children: _jsxs("div", __assign({ className: "flex w-full flex-col  " + 'two-cards' + "  " }, { children: [_jsxs("div", __assign({ className: "leading-padding" }, { children: [_jsx("p", __assign({ className: "mb-4 px-[24px] text-[18px] leading-[1.33] text-[#343741] md:mb-4 md:px-[45px] md:text-[22px] md:leading-[1.45] lg:text-[32px] lg:leading-[1.25] twocards_title twocards-padding ", style: { visibility: 'hidden' } }, { children: title }), void 0),
                        _jsx("hr", { className: "header-divider mx-[24px]  md:block twocards-margin new-spacer", style: {
                                borderTop: 'solid 1px #d8dcdb',
                                width: "" + (window.innerWidth >= 768 ? '100%' : ''),
                            } }, void 0)] }), void 0),
                _jsx("div", __assign({ className: "flex snap-x snap-mandatory  pr-[24px] pb-[40px] md:w-full " + (resourceCardList.length == 3
                        ? 'overflow-x-auto'
                        : 'overflow-x-auto ') + " md:px-0 twocards_cards " + (resourceCardList.length == 3 ? 'more_cards' : ''), onScroll: scrollHandler, style: {
                        visibility: 'hidden',
                        paddingLeft: "" + (resourceCardList.length == 3 ? '0px' : ''),
                        paddingBottom: "" + (isTablet ? '40px' : '48px'),
                    } }, { children: resourceCardList.map(function (resourceCard, i) { return (_jsx(ResourceCard, __assign({ className: "flex-shrink-0 snap-center " + (i !== resourceCardList.length - 1
                            ? 'mr-[24px] md:mr-[16px] xl:mr-[24px]'
                            : '') }, resourceCard), i)); }) }), void 0),
                (isMobile || (isTablet && resourceCardList.length > 2)) && (_jsx("div", __assign({ className: "mx-[24px] h-[1px] leading-padding " + (resourceCardList.length ? 'hideInXl' : 'md:hidden') + " " + (resourceCardList.length == 3 &&
                        window.innerWidth >= 1300 &&
                        'hidden'), style: {
                        backgroundColor: '#005f9e80',
                        // width: 'calc(100% - 48px)',
                        width: "" + (window.innerWidth >= 768 ? 'calc(100%)' : 'calc(100% - 48px)'),
                        margin: "" + (window.innerWidth >= 768 ? '0px 0px' : '0px 24px'),
                    } }, { children: _jsx("div", { className: "ml-[px] h-full w-[100px] bg-[#2d7fb6]", style: {
                            marginLeft: "calc(" + scrolledBy + "% - " + scrolledBy + "px)",
                        } }, void 0) }), void 0))] }), void 0) }), void 0));
};
TwoCards.defaultProps = defaultProps;
